<template>
  <el-dialog class="create-solidity-detector-task-dialog common-dialog" title="创建任务" :visible.sync="showDialog" top="25vh"
    @open="onShow">
    <el-form ref="createTask" :model="model" :rules="rules" :label-width="`${adaptationVars.formLabelWidth}px`">
      <el-form-item label="待检测合约" prop="contract">
        <el-select v-model="model.contract" placeholder="请选择合约">
          <el-option v-for="(item, index) in contractOptions" :key="index" :label="item.Filename"
            :value="item.ID"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合约函数名" prop="contractName">
        <el-input v-model="model.contractName"></el-input>
      </el-form-item>
      <el-form-item label="检测类型" prop="type">
        <el-select v-model="model.type" placeholder="请选择检测类型">
          <el-option v-for="(item, index) in typeOptions" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="最大调用层级" prop="maxInv">
        <el-input-number v-model="model.maxInv" controls-position="right" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="检测超时时间" prop="solveTimeOut">
        <el-input-number v-model="model.solveTimeOut" controls-position="right" :min="1"></el-input-number>
        ms
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateSolidityDetectorTask',
  components: {},
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 160
  },
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
      model: {
        contract: '',
        contractName: '',
        type: null,
        maxInv: 1,
        solveTimeOut: 10000
      },
      rules: {
        contract: [{ required: true, message: '请选择合约', trigger: 'blur' }],
        contractName: [
          { required: true, message: '请输入合约函数名', trigger: 'blur' },
          {
            type: 'string',
            pattern: /^[A-Za-z0-9_]+$/,
            message: '合约函数名应为英文、数字和下划线的组合',
            trigger: 'blur'
          }
        ],
        type: [{ required: true, message: '请选择检测类型', trigger: 'blur' }],
        maxInv: [{ required: true, message: '请输入函数最大调用层级', trigger: 'blur' }],
        solveTimeOut: [{ required: true, message: '请输入检测超时时间', trigger: 'blur' }]
      },
      typeOptions: [
        {
          id: 0,
          name: 'SUICIDAL'
        },
        {
          id: 1,
          name: 'PRODIGAL'
        },
        {
          id: 2,
          name: 'GREEDY'
        },
        {
          id: 3,
          name: 'TIMESTAMP'
        },
        {
          id: 4,
          name: 'DELEGATECALL'
        },
        {
          id: 5,
          name: 'REENTRANCY'
        },
        {
          id: 6,
          name: 'BLOCKINFO'
        },
        {
          id: 7,
          name: 'MISHANDLED_EXCEPTION'
        },
        {
          id: 8,
          name: 'INTEGER'
        }
      ],
      contractOptions: [],
      contractMap: {},
      showDialog: false,
      adaptationVars: {
        formLabelWidth: 160
      }
    }
  },
  watch: {
    dialogVisible: function (val) {
      this.showDialog = val
    },
    showDialog: function (val) {
      this.$emit('update:dialogVisible', val)
    },
    model: {
      handler(val, oldval) {
        // console.log(val)
      },
      deep: true
    }
  },
  mounted() { },
  methods: {
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$refs['createTask'].validate(valid => {
        if (valid) {
          console.log('submit!')

          // console.log(self.contractMap[self.model.contract])
          self.$apis.contractdetector
            .addSolidityDetectTask({
              ContractID: self.model.contract,
              ContractName: self.model.contractName,
              Check: self.model.type,
              MaxInv: self.model.maxInv,
              SolveTimeout: self.model.solveTimeOut
            })
            .then(res => {
              if (res && res.data && res.code === 1) {
                self.showDialog = false

                self.$emit('createSuccess')
                self.$message({
                  type: 'success',
                  message: '创建任务成功!'
                })
              } else {
                if (!res.error) {
                  self.$message({
                    type: 'error',
                    message: '创建任务失败!'
                  })
                } else {
                  const h = self.$createElement
                  self.$message({
                    type: 'error',
                    message: h('p', null, [
                      h('div', { style: 'color: red' }, '创建任务失败!'),
                      h('div', { style: 'color: teal' }, res.error)
                    ])
                  })
                }
              }
              // console.log(res)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onShow() {
      this.getContracts()
    },
    getContracts() {
      let self = this
      new Promise(async (resolve, reject) => {
        try {
          let contractOptions = []
          let res = await self.$apis.contractdetector.getSolidityContractList({
            offset: 0,
            limit: 20
          })
          if (res && res.data && res.code === 1) {
            contractOptions.push.apply(contractOptions, res.data.items)
            for (let i = 20; i < res.data.total; i += 20) {
              res = await self.$apis.contractdetector.getSolidityContractList({
                offset: i,
                limit: 20
              })
              contractOptions.push.apply(contractOptions, res.data.items)
            }
          }
          resolve(contractOptions)
        } catch (e) {
          console.log(e)
        }
      }).then(data => {
        // console.log('获取合约列表成功', data)
        self.contractOptions = data

        self.contractMap = {}
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          self.contractMap[item.ID] = item.Filename
        }

        if (data.length > 0) {
          self.model.contract = data[0].ID
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.create-solidity-detector-task-dialog {

  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--base-size-48);

  }

  .el-select {
    width: 100%;
  }
}
</style>
